module.exports = __webpack_public_path__ + "img/des_pintu_1.b9d98bc8.jpg";